import {
  ApplicationConfig,
  provideZoneChangeDetection,
  importProvidersFrom,
} from '@angular/core';

import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
  withFetch
} from '@angular/common/http';
import { routes } from './app.routes';
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
} from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideClientHydration,
  withNoHttpTransferCache,
  withNoIncrementalHydration,
} from '@angular/platform-browser';

// icons
// import { TablerIconsModule } from 'angular-tabler-icons';
// import * as TablerIcons from 'angular-tabler-icons/icons';

// perfect scrollbar
import { NgScrollbarModule } from 'ngx-scrollbar';
//Import all material modules
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideState, provideStore } from '@ngrx/store';
import { loadingReducer } from './store/loading.actions';
import { authClinicInterceptor } from './interceptors/auth-clinic.interceptor';
import { marketplaceAuthInterceptor } from './marketplace/services/marketplace-auth.interceptor';
import { customerReducer } from './store/cuustomer.actions';

export const appConfig: ApplicationConfig = {
  providers: [
    //manejo del estado global
    provideStore(),
    provideState({ name: 'loading', reducer: loadingReducer }),
    provideState({ name: 'customer', reducer: customerReducer }),
    //fin del manejo del estado global
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
      withComponentInputBinding()
    ),
    // Sin caché de transferencia: las páginas se prerenderizan en el build (ver
    // app.routes.server.ts) y lo que dependa de la hora —abierto ahora, turnos libres—
    // quedaría congelado en la respuesta del build. El navegador vuelve a pedirlo.
    provideClientHydration(withNoIncrementalHydration(), withNoHttpTransferCache()),
    provideAnimationsAsync(),

    // Un solo provideHttpClient: interceptors funcionales (token clinico + marketplace)
    // + los de DI si los hubiera. Antes se llamaba dos veces y el primero quedaba sin efecto.
    provideHttpClient(
      // fetch y no XHR: el prerender corre en Node, donde XMLHttpRequest no existe y los
      // pedidos quedaban colgados hasta el timeout. Nada en el app usa progreso de subida.
      withFetch(),
      withInterceptors([authClinicInterceptor, marketplaceAuthInterceptor]),
      withInterceptorsFromDi(),
    ),
    ///fin del interceptor

    importProvidersFrom(
      FormsModule,
      ReactiveFormsModule,
      MaterialModule,
      // TablerIconsModule.pick(TablerIcons),
      NgScrollbarModule
    ),
  ],
};
